import { initializeApp } from "firebase/app"; 
import { getFirestore, doc, setDoc, getDocs, query, where, collection } from "firebase/firestore";
import Cookies from "js-cookie";
import { Randomcode } from "./components/rendom_code";
 import { getStorage, ref, uploadBytes } from "firebase/storage";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut
} from "firebase/auth";

// Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "editortask.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Init
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);


export {app, auth, provider, db,storage };

// Dummy geo data placeholders
let usercountryname = "no";
let usercity = "no";
let userstate = "no";
let userpostcode = "no";
let userphonecode = "no";
let userlatitude = "no";
let userlongitude = "no";
let useraddress = "no";
let deviceName= "no";

 //deviceName=<DeviceInfo />; 

// This forces account selection every time
provider.setCustomParameters({
  prompt: "select_account"
});
 



// Sign in with Google
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    const emailid = user.email?.toString().trim().toLowerCase();

    // const userQuery = query(collection(db, "users"), where("email", "==", emailid));
    // const userSnap = await getDocs(userQuery);

    let guid, displayName, photoURL;

    // Check if email already exists in "accounts"
    const checkQuery = query(collection(db, "users"), where("email", "==", emailid));
    const checkSnap = await getDocs(checkQuery);
 
    if (checkSnap.empty) {
      // New user
      guid = Randomcode(18);
      displayName = user.displayName;
      photoURL = user.photoURL;
      const slug = Randomcode(12).toLowerCase();
 
      const newuserRef = doc(collection(db, "users")); // Auto-generated ID
      await setDoc(newuserRef, {
        guid,
        email: emailid,
        name: user.displayName,
        subscriber:0,
        city: usercity,
        postcode: userpostcode,
        state: userstate,
        country: usercountryname,
        address: useraddress,
        latitude: userlatitude,
        longitude: userlongitude,
        device: navigator.userAgent,
        deviceName: deviceName,
        cover: 'https://firebasestorage.googleapis.com/v0/b/editortaskcom.firebasestorage.app/o/company_logo%2Fcovers_img.jpg?alt=media&token=1b9aca37-292e-438a-87c2-19c02e19455b',
        phonecode: userphonecode.replaceAll("+", ""),
        phone: user.phoneNumber || "",
        rating: 1,
        reviews: 0,
        slug,
        status: true,
        industry:"",
        verification: false,
        role: "user",
        bio: "Short profile description",
        photoURL: user.photoURL,
        verification_date_time: new Date(),
        updated_datetime: new Date(),
        datetime: new Date()
      });
    } else {
      // Existing user
      const userDoc = checkSnap.docs[0];
      const userData = userDoc.data();
      guid = userData.guid;
      displayName = userData.name;
      photoURL = userData.photoURL;
    }

    const uid = Randomcode(12);
    const loginRef = doc(db, "users_login", uid);
    await setDoc(loginRef, {
      guid,
      uid,
      email: emailid || "",
      name: displayName,
      city: "Unknown City", // replace if available
      postcode: "000000",
      state: "Unknown State",
      country: "Unknown Country",
      address: "Unknown Address",
      latitude: 0.0,
      longitude: 0.0,
      photoURL,
      deviceName: "Unknown Device",
      device: navigator.userAgent,
      emailuid: user.uid,
      app_version: "1.1.5",
      status: true,
      date_time: new Date()
    });

    Cookies.set("guid", guid, { expires: 365 });
     Cookies.set("adminguid", guid, { expires: 365 });
    Cookies.set("login_name", displayName, { expires: 365 });
    Cookies.set("login_photoURL", photoURL, { expires: 365 });
    Cookies.set("loginkey", uid, { expires: 365 });

    console.log("✅ User signed in and login saved");
    window.location.reload();
  } catch (error) {
    console.error("❌ Google Sign-In Error:", error);
  }
};

 
// Handle auth state
export const checkUserAuth = (setUser) => {
 
 
};

// Logout
export const googleLogout = async () => {
  try {
    await signOut(auth);
    Cookies.remove("guid");
    Cookies.remove("login_name");
    Cookies.remove("login_photoURL");
    Cookies.remove("loginkey");
    console.log("✅ Logged out");
  } catch (error) {
    console.error("❌ Logout Error:", error);
  }
};
